import { loggerManager } from '@leyan/logger';

const logger = loggerManager.getLogger('stove');

export default logger;
